<template>
	<span class="degree-badge d-inline-flex align-center" :title="label">
		<span class="degree-badge__swatch" :style="{ backgroundColor: color }"></span>
		<span v-if="showLabel" class="degree-badge__label ml-1">{{ label }}</span>
	</span>
</template>

<script>
import { roastDegreeColor, roastDegreeLabel } from './roastLabels'

export default {
	name: 'RoastDegreeBadge',
	props: {
		degree: { type: String, default: '' },
		showLabel: { type: Boolean, default: true },
		/** meta 项可自带 color / title，优先使用 */
		colorOverride: { type: String, default: '' },
		labelOverride: { type: String, default: '' }
	},
	computed: {
		color() {
			return this.colorOverride || roastDegreeColor(this.degree)
		},
		label() {
			return this.labelOverride || roastDegreeLabel(this.degree) || this.degree || '—'
		}
	}
}
</script>

<style scoped>
.degree-badge__swatch {
	width: 0.85rem;
	height: 0.85rem;
	border-radius: 50%;
	flex-shrink: 0;
	border: 1px solid rgba(0, 0, 0, 0.18);
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.15);
}
</style>
